import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import ModuleEditForm from './ModuleEditForm';
import ModuleEditDialogHeader from './ModuleEditDialogHeader';

const ModuleEditDialog = ({ show, onHide, id, isEdit, rtl }) => {
  const [modal, setModal] = useState({
    isOpen: show,
    title: `${isEdit ? 'Edit' : 'Add'} Module`,
    hide: onHide,
  });

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-edit-dialog"
    >
      <ModuleEditDialogHeader modal={modal} />
      <ModuleEditForm modal={modal} isEdit={isEdit} id={id ? +id : ''} />
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(ModuleEditDialog);
